import Box from "@material-ui/core/Box";
import React, { FunctionComponent, useMemo } from "react";
import styled from "styled-components";
import { Flex } from "../layout";
import { colours } from "../../styles/colours";

const Percentage = styled.div<{ isSmall?: boolean }>`
  color: ${colours.darkGrey};
  font-size: ${(props) => (props.isSmall ? "0.8em" : "1.5em")};
`;

const Container = styled(Flex)`
  flex-direction: column;
  margin-bottom: 1em;
`;
const Label = styled.div`
  margin: 0.5em;
`;

const sizeMap = {
  small: 40,
  medium: 100,
  large: 200,
};

const SvgWrapper = styled.div`
  position: relative;
`;

const Svg = styled.svg`
  position: absolute;
`;

const BackgroundCircle = styled.circle`
  stroke: ${colours.lightGrey};
`;

const ForegroundCircle = styled.circle<{ risk: "low" | "medium" | "high" }>`
  ${(props) => (props.risk === "low" ? `stroke: ${colours.green}` : "")};
  ${(props) => (props.risk === "medium" ? `stroke: ${colours.yellow}` : "")};
  ${(props) => (props.risk === "high" ? `stroke: ${colours.red}` : "")};
`;

export const Score: FunctionComponent<{
  value: number;
  title: string;
  size?: keyof typeof sizeMap;
}> = ({ value, title, size = "medium" }) => {
  const risk = useMemo(() => {
    if (value < 40) return "low";
    if (value < 75) return "medium";
    return "high";
  }, [value]);

  return (
    <Container>
      <Label>{title}</Label>
      <Box position="relative" display="inline-flex">
        <SvgWrapper
          className="MuiCircularProgress-root MuiCircularProgress-colorPrimary MuiCircularProgress-determinate"
          style={{
            width: sizeMap[size],
            height: sizeMap[size],
            transform: "rotate(135deg)",
          }}
        >
          <Svg className="MuiCircularProgress-svg" viewBox="22 22 44 44">
            <BackgroundCircle
              className="MuiCircularProgress-circle MuiCircularProgress-circleDeterminate"
              cx="44"
              cy="44"
              r="20.2"
              fill="transparent"
              stroke-width="3.6"
              style={{
                strokeDasharray: 126.92,
                strokeDashoffset: 0.25 * 126.92,
              }}
            ></BackgroundCircle>
          </Svg>
          <Svg className="MuiCircularProgress-svg" viewBox="22 22 44 44">
            <ForegroundCircle
              className="MuiCircularProgress-circle MuiCircularProgress-circleDeterminate"
              cx="44"
              cy="44"
              r="20.2"
              risk={risk}
              fill="transparent"
              stroke-width="3.6"
              style={{
                strokeDasharray: 126.92,
                strokeDashoffset: (1 - (value / 100) * 0.75) * 126.92,
              }}
            ></ForegroundCircle>
          </Svg>
        </SvgWrapper>
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Percentage isSmall={size === "small"}>{`${Math.round(
            value
          )}%`}</Percentage>
        </Box>
      </Box>
    </Container>
  );
};
